import Vue from 'vue'
import Vuex from 'vuex'
import * as fb from '../firebase'
import router from '../router/index'
import createPersistedState from "vuex-persistedstate";
import AccountService from "@/services/AccountService";

Vue.use(Vuex)

const store = new Vuex.Store({
  plugins: [createPersistedState()],
  state: {
    userProfile: {},
    telegram_chat_id: '-1001359112082',
    telegram_rekt_traders_chat_id: '-1001804791694',
  },
  mutations: {
    setUserProfile(state, val) {
      state.userProfile = val
    },
    setPerformingRequest(state, val) {
      state.performingRequest = val
    },
    setPosts(state, val) {
      state.posts = val
    }
  },
  actions: {
    async login({ dispatch }, form) {
      // sign user in
      const { user } = await fb.auth.signInWithEmailAndPassword(form.email, form.password)

      // fetch user profile and set in state
      dispatch('fetchUserProfile', user)
    },
    async signup({ dispatch }, form) {
      const registerRequest = await AccountService.register(form.code)
      if (registerRequest.data.success) {
        // sign user up
        const { user } = await fb.auth.createUserWithEmailAndPassword(form.email, form.password)
        // create user object in userCollections
        await AccountService.createAccount(form.code)
        // fetch user profile and set in state
        dispatch('fetchUserProfile', user)
      } else {
       throw new Error('Invalid code')
      }
    },
    async fetchUserProfile({ commit }, user) {
      // fetch user profile
      const userProfile = await fb.usersCollection.doc(user.uid).get()
      const idTokenResult = await fb.auth.currentUser.getIdTokenResult()
      const profileData = userProfile.data() || {}
      const accessScope =
        idTokenResult.claims.access_scope || profileData.access_scope || null
      // set user profile in state
      commit('setUserProfile', {
        ...profileData,
        uid: user.uid,
        isAdmin: !!idTokenResult.claims.admin,
        access_scope: accessScope,
        isWhopLessons: accessScope === 'lessons' || !!idTokenResult.claims.whop,
      })

      const authEntryPaths = ['/login', '/register', '/login/whop']
      if (authEntryPaths.includes(router.currentRoute.path)) {
        if (accessScope === 'lessons') {
          await router.push('/education/pdf-lessons')
        } else {
          await router.push('/account')
        }
      }
    },
    async loginWithCustomToken({ dispatch }, customToken) {
      const { user } = await fb.auth.signInWithCustomToken(customToken)
      await user.getIdToken(true)
      await dispatch('fetchUserProfile', user)
    },
    async logout({ commit }) {
      // log user out
      await fb.auth.signOut()

      // clear user data from state
      commit('setUserProfile', {})

      // redirect to login view
      await router.push('/login')
    }
  }
})

export default store
